<template>
  <v-row>
    <v-col cols="12">
      <div id="invoiceAttachment" style="break-after: auto">
        <div class="black--text">
          <table class="Full-Width">
            <tbody>
              <tr>
                <td>
                  <table class="Full-Width">
                    <tbody>
                      <tr>
                        <td width="45%">
                          <p class="text-h5 font-weight-bold mb-0">
                            Momentum Logistics LLC
                          </p>
                          <p class="text-h6 font-weight-medium mb-0">
                            A Gulftainer Company
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            P.O.Box 225, Sharjah - UAE
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            Tel : +971 6 5062000
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            Telefax : +971 (6) 5587528
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            E-mail : info@momentumlogistics.com
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            TRN : 100290916400003
                          </p>
                        </td>

                        <td width="33%">
                          <img
                            alt="Brand Logo"
                            class="Brand-Logo"
                            src="@/assets/images/brand-logo.png"
                          />
                          <p class="text-h6 font-weight-medium ml-3">
                            A Gulftainer Company
                          </p>
                        </td>

                        <td width="22%">
                          <!-- <p class="text-h5 font-weight-bold mb-0">
                            ـومـيـنـتـوم الـلـوجـسـتـيـة ذ م م
                          </p>
                          <p class="text-h6 font-weight-medium mb-0">
                            شركة غلفتينر
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            P.O.Box 225, Sharjah - UAE
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            Tel : +971 6 5062000
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            Telefax : +971 (6) 5587528
                          </p>
                          <p class="text-subtitle-1 mb-0">
                            E-mail : info@momentumlogistics.com
                          </p> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <v-divider></v-divider>
                </td>
              </tr>

              <tr>
                <td class="text-center">
                  <p class="text-h5 font-weight-bold my-4">Tax Invoice</p>
                </td>
              </tr>

              <tr>
                <td>
                  <table class="Full-Width">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <v-row>
                            <v-col cols="12" lg="7">
                              <table>
                                <tbody>
                                  <tr>
                                    <th class="text-left Vertical-Align">
                                      Invoice To
                                    </th>
                                    <th class="px-4 Vertical-Align">:</th>
                                    <td
                                      class="text-left"
                                      v-if="
                                        'company_details' in invoiceDetails &&
                                        invoiceDetails.company_details
                                      "
                                    >
                                      <p class="pa-0 ma-0">
                                        {{
                                          invoiceDetails.company_details
                                            .company_code
                                        }}
                                      </p>
                                      <p class="pa-0 ma-0">
                                        {{
                                          invoiceDetails.company_details
                                            .company_name
                                        }}
                                      </p>
                                      <p class="pa-0 ma-0">
                                        {{
                                          invoiceDetails.company_details
                                            .address_detail.address
                                        }}
                                      </p>
                                      <p class="pa-0 ma-0">
                                        {{
                                          invoiceDetails.company_details
                                            .full_company_contact_number
                                        }}
                                      </p>
                                    </td>

                                    <td v-else>
                                      <p
                                        class="pa-0 ma-0"
                                        v-if="invoiceDetails.company_code"
                                      >
                                        {{ invoiceDetails.company_code }}
                                      </p>
                                      <p
                                        class="pa-0 ma-0"
                                        v-if="invoiceDetails.company_name"
                                      >
                                        {{ invoiceDetails.company_name }}
                                      </p>
                                      <p
                                        class="pa-0 ma-0"
                                        v-if="invoiceDetails.company_address"
                                      >
                                        {{ invoiceDetails.company_address }}
                                      </p>
                                      <p
                                        class="pa-0 ma-0"
                                        v-if="
                                          invoiceDetails.company_contact_number
                                        "
                                      >
                                        {{
                                          invoiceDetails.company_contact_number
                                        }}
                                      </p>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td colspan="3">
                                      <br />
                                    </td>
                                  </tr>

                                  <tr>
                                    <th class="text-left">TRN</th>
                                    <th class="px-4">:</th>
                                    <td
                                      class="text-left"
                                      v-if="invoiceDetails.company_vat_number"
                                    >
                                      {{ invoiceDetails.company_vat_number }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-col>

                            <v-col cols="12" lg="5">
                              <table>
                                <tbody>
                                  <tr v-if="invoiceDetails.invoice_no">
                                    <th class="text-left">Invoice No</th>
                                    <th class="px-4">:</th>
                                    <td>{{ invoiceDetails.invoice_no }}</td>
                                  </tr>

                                  <tr v-if="invoiceDetails.invoice_date">
                                    <th class="text-left">Invoice Date</th>
                                    <th class="px-4">:</th>
                                    <td>
                                      {{
                                        invoiceDetails.invoice_date
                                          | formatDate(false)
                                      }}
                                    </td>
                                  </tr>
                                  <tr v-if="invoiceDetails.invoice_type">
                                    <th class="text-left">Invoice Type</th>
                                    <th class="px-4">:</th>
                                    <td>
                                      {{ invoiceDetails.invoice_type }}
                                    </td>
                                  </tr>
                                  <tr v-if="invoiceDetails.boe">
                                    <th class="text-left">BOE</th>
                                    <th class="px-4">:</th>
                                    <td>
                                      {{ invoiceDetails.boe }}
                                    </td>
                                  </tr>
                                  <tr
                                    v-if="invoiceDetails.invoice_type == 'LPO'"
                                  >
                                    <th class="text-left">PO No</th>
                                    <th class="px-4">:</th>
                                    <td>
                                      {{ invoiceDetails.po_no }}
                                    </td>
                                  </tr>
                              
                                  <tr>
                                    <th class="text-left">TRL Type </th>
                                    <th class="px-4">:</th>
                                     
                                    <td>
                                      {{
                                        invoiceDetails.delivery_advice_details[0].vessel_no
                                          ? invoiceDetails.delivery_advice_details[0].vessel_no
                                          : "NIL"
                                      }}
                                    </td>
                                  </tr>

                                  <tr v-if="invoiceDetails.job_type">
                                    <th class="text-left">Job Type</th>
                                    <th class="px-4">:</th>
                                    <td>{{ invoiceDetails.job_type }}</td>
                                  </tr>

                                  <tr>
                                    <td colspan="3">
                                      <br />
                                    </td>
                                  </tr>

                                  <!-- <tr>
                                    <th class="text-left">INTL. FREIGHT</th>
                                    <th class="px-4">:</th>
                                    <td>
                                      <v-checkbox
                                        hide-details="auto"
                                        color="grey"
                                        readonly
                                        class="Check-Box"
                                        v-model="
                                          invoiceDetails.is_international_freight
                                        "
                                        true-value="Yes"
                                        false-value="No"
                                      ></v-checkbox>
                                    </td>
                                  </tr> -->
                                </tbody>
                              </table>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr v-if="invoiceDetails.departure_country">
                        <th class="text-left">
                          {{
                            ["Local"].indexOf(
                              invoiceDetails.invoice_type
                            ) >= 0
                              ? "Ship From"
                              : "Source Point"
                          }}
                        </th>
                        <th class="px-4">:</th>
                        <td>
                          {{ invoiceDetails.delivery_advice_details[0].source_point }}
                        </td>
                      </tr>

                      <tr v-if="invoiceDetails.mid_country">
                        <th class="text-left">
                          {{
                            ["Local"].indexOf(
                              invoiceDetails.invoice_type
                            ) >= 0
                              ? "Ship To"
                              : "Mid Point"
                          }}
                        </th>
                        <th class="px-4">:</th>
                      
                        <td>
                          {{ invoiceDetails.delivery_advice_details[0].mid_point }}
                        </td>
                      </tr>
                      <tr v-if="invoiceDetails.destination_country">
                        <th class="text-left">Destination Point</th>
                        <th class="px-4">:</th>
                       
                        <td>
                          {{ invoiceDetails.delivery_advice_details[0].destination_point }}
                        </td>
                      </tr>

                      <tr v-if="invoiceDetails.branch">
                        <th class="text-left">Service Location</th>
                        <th class="px-4">:</th>
                        <td>{{ invoiceDetails.branch }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table class="Full-Width Invoice-Table">
                    <thead>
                      <tr>
                        <th class="text-left">SR No</th>
                        <th class="text-left">Description</th>
                        <th class="text-right">Unit Price</th>
                        <th
                          class="text-right"
                          v-if="invoiceDetails.invoice_type == 'LPO'"
                        >
                          QTY
                        </th>
                        <th class="text-right">TAX Rate %</th>
                        <th class="text-right">
                          TAX Amount ({{ $globals.currency }})
                        </th>
                        <th class="text-right">
                          Gross Amount ({{ $globals.currency }})
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(charge, i) in invoiceDetails.invoice_charges"
                        :key="i"
                      >
                        <td>{{ i + 1 }}</td>
                        <td>{{ charge.charge_title }}</td>

                        <td
                          class="text-right"
                          v-if="
                            charge.da_unit_rate &&
                            invoiceDetails.invoice_type == 'LPO'
                          "
                        >
                          {{ charge.da_unit_rate }}
                        </td>
                        <td class="text-right" v-else>{{ charge.rate | formatNumber(true) }}</td>

                        <td
                          class="text-right"
                          v-if="
                            charge.charge_type == 'Freight' &&
                            invoiceDetails.invoice_type == 'LPO'
                          "
                        >
                          {{ charge.qty }}
                        </td>
                        <td
                          class="text-right"
                          v-else-if="invoiceDetails.invoice_type == 'LPO'"
                        >
                          -
                        </td>

                        <td class="text-right">
                          {{ `${charge.tax_percentage} %` }}
                        </td>
                        <td class="text-right">
                          {{ charge.tax_amount | formatNumber(true) }}
                        </td>
                        <td class="text-right">{{ charge.gross_amount | formatNumber(true) }}</td>
                      </tr>

                      <tr>
                        <td colspan="2" class="font-weight-bold">
                          Grand Total ({{ $globals.currency }}) :
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ invoiceDetails.total_amount | formatNumber(true) }}
                        </td>
                        <td
                          class="font-weight-bold text-right"
                          v-if="invoiceDetails.invoice_type == 'LPO'"
                        ></td>
                        <td colspan="2" class="font-weight-bold text-right">
                          {{ invoiceDetails.total_tax_amount | formatNumber(true) }}
                        </td>
                        <td class="font-weight-bold text-right">
                          {{ invoiceDetails.total_gross_amount | formatNumber(true) }}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="8">
                          <span class="text-subtitle-1 font-weight-bold">
                            {{ $globals.currency }}
                          </span>
                          <span class="text-subtitle-1">
                            {{ invoiceDetails.total_gross_amount_words }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <th>Remarks :</th>
                        <td>{{ invoiceDetails.remarks }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <v-row class="my-10 px-3">
                    <v-col cols="12">
                      <span class="text-subtitle-1">
                        Please Remit Payment To :
                      </span>
                    </v-col>
                    <v-col
                      cols="6"
                      class="
                        Border-Top-Class Border-Left-Class Border-Right-Class
                      "
                    >
                      <table>
                        <tbody>
                          <tr>
                            <th class="text-left">Account Name & Address :</th>
                          </tr>
                          <tr>
                            <td>Momentum Logistics LLC</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>

                    <v-col cols="6" class="Border-Top-Class Border-Right-Class">
                      <table>
                        <tbody>
                          <tr>
                            <th class="text-left">Swift Code :</th>
                            <td>NBSHAEAS</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>

                    <v-col
                      cols="6"
                      class="
                        Border-Bottom-Class
                        Border-Top-Class
                        Border-Left-Class
                        Border-Right-Class
                      "
                    >
                      <table>
                        <tbody>
                          <tr>
                            <th class="text-left">Bank Name & Address :</th>
                          </tr>
                          <tr>
                            <td>Sharjah Islamic Bank Main Branch - Sharjah</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>

                    <v-col
                      cols="6"
                      class="
                        Border-Bottom-Class Border-Top-Class Border-Right-Class
                      "
                    >
                      <table>
                        <tbody>
                          <tr>
                            <th class="text-left">Account Number :</th>
                            <td>0011371164001</td>
                          </tr>
                          <tr>
                            <th class="text-left">IBAN :</th>
                            <td>AE950410000011371164001</td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>
                  </v-row>
                </td>
              </tr>

              <tr>
                <td>
                  <table class="Full-Width">
                    <tbody>
                      <tr>
                        <td>
                          <span class="text-subtitle-1 font-weight-bold">
                            Processed By :
                          </span>
                        </td>

                        <td>
                          <span class="text-subtitle-1 font-weight-bold">
                            Approved By :
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <span class="text-subtitle-1">
                    Discrepancy, if any, noted should be alerted to us within 14
                    days of receipt of the invoice or else the invoice would be
                    considered as accepted.
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    invoiceDetails: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
#invoiceAttachment {
  font-family: "Roboto", sans-serif !important;
}

.Invoice-Table,
.Invoice-Table th,
.Invoice-Table td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
  margin-top: 12px;
}

.Border-Top-Class {
  border-top: 1px solid black;
}

.Border-Bottom-Class {
  border-bottom: 1px solid black;
}

.Border-Left-Class {
  border-left: 1px solid black;
}

.Border-Right-Class {
  border-right: 1px solid black;
}

.Brand-Logo {
  width: 200px;
}

.d-flex {
  display: flex !important;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.Vertical-Align {
  vertical-align: top;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.px-3 {
  padding-right: 12px !important;
  padding-left: 12px !important;
}

.px-4 {
  padding-right: 16px !important;
  padding-left: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.text-h5 {
  font-size: 1.5rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif !important;
}

.text-h6 {
  font-size: 1.25rem !important;
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: 0.0125em !important;
  font-family: "Roboto", sans-serif !important;
}

.text-subtitle-1 {
  font-size: 1rem !important;
  font-weight: normal;
  line-height: 1.75rem;
  letter-spacing: 0.009375em !important;
  font-family: "Roboto", sans-serif !important;
}

.font-weight-medium {
  font-weight: 500 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.Check-Box {
  margin-top: 0px;
  padding-top: 0px;
}

.Check-Box
  .v-input__control
  .v-input__slot
  .v-input--selection-controls__input
  .v-input--selection-controls__ripple {
  height: 25px;
  width: 25;
  left: 0px;
  top: calc(50% - 13px);
  margin: 0px;
}
</style>
